import { createNavigation } from 'next-intl/navigation';
import { localePrefix, locales } from './config';

export { useSearchParams } from 'next/navigation';

// Expand this dictionary as the use cases for filter flag grows
export const ROUTE_FILTERS = {
  COMPATIBILITY: 'compatibility',
  COMPETITOR: 'competitor',
};

export const {
  Link: RouterLink,
  redirect,
  usePathname,
  useRouter,
} = createNavigation({ locales, localePrefix });
